import { render, staticRenderFns } from "./order-detail-cj.vue?vue&type=template&id=b499c4d0&scoped=true&"
import script from "./order-detail-cj.vue?vue&type=script&lang=js&"
export * from "./order-detail-cj.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-cj.vue?vue&type=style&index=0&id=b499c4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b499c4d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b499c4d0')) {
      api.createRecord('b499c4d0', component.options)
    } else {
      api.reload('b499c4d0', component.options)
    }
    module.hot.accept("./order-detail-cj.vue?vue&type=template&id=b499c4d0&scoped=true&", function () {
      api.rerender('b499c4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/order-manager/order-detail-cj.vue"
export default component.exports